import React from "react";

const ClaimedSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Claimed</title>
      <path
        d="M5.54997 11.596L0.422974 6.46925L1.49222 5.4L5.54997 9.45775L14.5077 0.5L15.577 1.56925L5.54997 11.596ZM1.49997 15.5V14H14.5V15.5H1.49997Z"
        fill="#5663F2"
      />
    </svg>
  );
};

export default ClaimedSvg;
